import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import ConfirmAccion from "@/components/lifecycle/ConfirmAccion";

/**
 * Panel de configuración de un recurso: lifecycle fuera del flujo principal.
 * "Estado y acceso" es secundario; "Avanzado" (hard-delete) queda al final y protegido.
 */
export default function ConfiguracionLifecycle({ open, onOpenChange, titulo, inactivo,
  explicacion, labelActivar, labelDesactivar, confirmar, onToggle, testPrefix, children }) {
  const [pedirConfirmacion, setPedirConfirmacion] = useState(false);
  const c = inactivo ? confirmar.activar : confirmar.desactivar;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right"
        className="w-full sm:max-w-md overflow-y-auto p-0" data-testid={`${testPrefix}-configuracion-panel`}>
        <SheetHeader className="px-5 pt-6 pb-4 border-b border-gray-100 text-left">
          <SheetTitle className="text-[#012472] break-words text-lg">{titulo}</SheetTitle>
          <SheetDescription className="text-xs text-slate-500">
            Ajustes de estado y acciones administrativas.
          </SheetDescription>
        </SheetHeader>

        <div className="px-5 py-5 space-y-8">
          <section className="space-y-3">
            <p className="text-[11px] font-medium uppercase tracking-wider text-slate-400">Estado y acceso</p>
            <div className="flex items-center gap-2">
              <span data-testid={`${testPrefix}-estado-actual`}
                className={`text-xs rounded-full px-2.5 py-1 ${inactivo ? "bg-slate-100 text-slate-500" : "bg-emerald-50 text-emerald-700"}`}>
                {inactivo ? "Inactiva" : "Activa"}
              </span>
            </div>
            <p className="text-xs text-slate-500 leading-relaxed">{explicacion}</p>
            <Button variant="outline" className="rounded-xl w-full min-h-[44px]"
              data-testid={`${testPrefix}-toggle-estado`} onClick={() => setPedirConfirmacion(true)}>
              {inactivo ? labelActivar : labelDesactivar}
            </Button>
          </section>

          <section className="space-y-3">
            <p className="text-[11px] font-medium uppercase tracking-wider text-slate-400">Avanzado</p>
            {children}
          </section>
        </div>

        <ConfirmAccion open={pedirConfirmacion} onOpenChange={setPedirConfirmacion}
          titulo={c.titulo} texto={c.texto} nota={c.nota} confirmLabel={c.boton}
          testPrefix={testPrefix}
          onConfirm={async () => {
            const ok = await onToggle();
            if (ok !== false) setPedirConfirmacion(false);
          }} />
      </SheetContent>
    </Sheet>
  );
}
